import { __assign } from "tslib";
import { getURI } from './uri';
function getSrcset(fittingType, src, target, options, data) {
    var dpr = target.pixelAspectRatio || 1;
    return {
        dpr: [
            (dpr === 1
                ? data.uri
                : getURI(fittingType, src, __assign(__assign({}, target), { pixelAspectRatio: 1 }), options)) + " 1x",
            (dpr === 2
                ? data.uri
                : getURI(fittingType, src, __assign(__assign({}, target), { pixelAspectRatio: 2 }), options)) + " 2x",
        ],
    };
}
export { getSrcset };
//# sourceMappingURL=srcset.js.map